export default "__VITE_ASSET__S9J$a7je__"